// extracted by mini-css-extract-plugin
export var arrow = "_lj-1";
export var content = "_lj-0";
export var highlighted = "_lj-2";